<!------------------------------------------------------------------------------
  - Copyright (c) 2019. BMW Group. All rights reserved.
  ----------------------------------------------------------------------------->

<div #tooltip="ngbTooltip"
     (mouseenter)="tooltipToggle.emit(true)"
     (mouseleave)="tooltipToggle.emit(false)"
     [autoClose]="autoClose"
     [ngbTooltip]="tooltipBody"
     [disableTooltip]="disable"
     [placement]="placement"
     [tooltipClass]="tooltipClass"
     [triggers]="triggers">
    <ng-content></ng-content>
</div>
